module.exports = __webpack_public_path__ + "img/Group 8910white.be3a2dee.svg";